export const QUOTE_STAGE = {
  ACCEPTED: 'Presupuesto aceptado',
  ON_HOLD: 'Presupuesto en espera',
  CANCELLED: 'Presupuesto Anulado',
  PARALYZED: 'Presupuesto Paralizado',
  REJECTED: 'Presupuesto rechazado',
  REVISED: 'Presupuesto revisado',
  PREACCEPTED: 'Presupuesto preaceptado'
} as const;